import {IDomainCheckFeature} from 'entities/monitor';

export function getVisibleDomainChecks(
    checks: IDomainCheckFeature[],
    isEnglish: boolean,
    activeKeys?: string[],
): IDomainCheckFeature[] {
    return checks
        .filter(check => !(isEnglish && check.name === 'rkn_watch'))
        .filter(check => !activeKeys || activeKeys.includes(check.name));
}
